import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledInputWrapper = styled.div `
    display: inline-block;
    position: relative;
    margin-bottom: 20px;
    margin-right: 20px;
    width: ${props => (props.width ? props.width : 'auto')};

    &:last-child {
        margin-right: 0;
    }

    &:first-child&:last-child {
        margin: 0;
    }
`;
const InputWrapper = ({ children, width, className, ...props }) => (_jsx(StyledInputWrapper, { className: className, width: width, ...props, children: children }));
export default InputWrapper;
